import classNames from "classnames";
import React from "react";

import { ODSText } from "../ODSText";
import { ODSBreadcrumbItemProps } from "./ODSBreadcrumb.types";

import "./css/index.css";
import { Slot } from "@radix-ui/react-slot";

const ODSBreadcrumbItem: React.FC<ODSBreadcrumbItemProps> = ({
  className,
  text,
  selected = false,
  asChild = false,
  children,
  ...rest
}) => {
  const Comp = asChild ? Slot : "a";

  return (
    <Comp
      className={classNames(
        `ODSBreadcrumbItem`,
        selected && `ODSBreadcrumbItem--selected`,
        className
      )}
      aria-label={text}
      tabIndex={selected ? -1 : 0}
      aria-current={selected ? "page" : undefined}
      {...rest}
    >
      {asChild ? (
        children
      ) : (
        <ODSText as="span" className="ODSBreadcrumbItem-Text">
          {text}
        </ODSText>
      )}
    </Comp>
  );
};

export default ODSBreadcrumbItem;
